import React, { createContext, useContext, useState, useCallback } from 'react';

const UserProfileContext = createContext();

export const UserProfileProvider = ({ children }) => {
  const [userProfile, setUserProfile] = useState({
    displayName: '',
    email: '',
    photoURL: '',
    uid: '',
    occupation: '',
    classYear: '',
    linkedin: '',
    instagram: '',
    bio: '',
    companies: [],
    courses: [],
    coursesTaught: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const updateUserProfile = useCallback((newProfile) => {
    setUserProfile(prevProfile => ({ ...prevProfile, ...newProfile }));
  }, []);

  const updateProfileField = useCallback((field, value) => {
    setUserProfile(prevProfile => ({ ...prevProfile, [field]: value }));
  }, []);

  const clearUserProfile = useCallback(() => {
    setUserProfile({
      displayName: '',
      email: '',
      photoURL: '',
      uid: '',
      occupation: '',
      classYear: '',
      linkedin: '',
      instagram: '',
      bio: '',
      companies: [],
      courses: [],
      coursesTaught: [],
    });
  }, []);

  const setLoadingState = useCallback((isLoading) => {
    setLoading(isLoading);
  }, []);

  const setErrorState = useCallback((errorMessage) => {
    setError(errorMessage);
  }, []);

  return (
    <UserProfileContext.Provider
      value={{
        userProfile,
        updateUserProfile,
        updateProfileField,
        clearUserProfile,
        loading,
        setLoadingState,
        error,
        setErrorState
      }}
    >
      {children}
    </UserProfileContext.Provider>
  );
};

export const useUserProfile = () => {
  const context = useContext(UserProfileContext);
  if (!context) {
    throw new Error('useUserProfile must be used within a UserProfileProvider');
  }
  return context;
};